import React, { useContext, useState } from 'react';
import { Pane, Dialog, TextInputField, FilePicker, CloudUploadIcon, Button, PlusIcon, ChevronLeftIcon, ChevronRightIcon, DeleteIcon, SelectField } from 'evergreen-ui';

//Context
import PosNegociacaoContext from '../../../../../../context/PosNegociacaoContext';

//Components
import Axios from 'axios';
import Serve from '../../../../../../app/serve';
import { useHistory } from 'react-router-dom';
import Steps from './Steps';
//import cepMask from '../../../../../../components/cepMask';
//import somenteNumero from '../../../../../../components/somenteNumero';
//import dateMask from '../../../../../../components/dateMask';
import cpfMask from '../../../../../../components/cpfMask';
import phoneMask from '../../../../../../components/phoneMask';

export default function Comprador() {

    const app = Serve();
    const history = useHistory();
    const [token] = useState(localStorage.getItem('token'));
    //const idProcesso = props.idProcesso;

    const {
        isShowFormEspelhoVenda, setIsShowFormEspelhoVenda,
        posicaoEspelhoVenda, setPosicaoEspelhoVenda,
        tipoDocumentos, setTipoDocumentos,
        dadosEspelhoComprador, setDadosEspelhoComprador,
    } = useContext(PosNegociacaoContext);

    console.log(posicaoEspelhoVenda);

    const [validateCpfComprador, setValidateCpfComprador] = useState(false);
    const [validateNomeComprador, setValidateNomeComprador] = useState(false);
    //const [validateCodigoComprador, setValidateCodigoComprador] = useState(false);
    const [validateTelefoneComprador, setValidateTelefoneComprador] = useState(false);
    //const [validateEmailComprador, setValidateEmailComprador] = useState(false);
    //const [validateCepComprador, setValidateCepComprador] = useState(false);
    const [validateBairroComprador, setValidateBairroComprador] = useState(false);
    const [validateLogradouroComprador, setValidateLogradouroComprador] = useState(false);
    //const [validateConjugeComprador, setValidateConjugeComprador] = useState(false);
    //const [validateProcuradorComprador, setValidateProcuradorComprador] = useState(false);
    //const [validateTelefoneProcuradorComprador, setValidateTelefoneProcuradorComprador] = useState(false);
    //const [validateFieldDocumentos, setValidateFieldDocumentos] = useState(false);
    const [validateDocObrigatorio, setValidateDocObrigatorio] = useState(false);
    const [formValues, setFormValues] = useState([{ tipoDocumento: "", documento: "" }])

    const closeEspelhoVenda = (e) => {
        setIsShowFormEspelhoVenda(false);
        setPosicaoEspelhoVenda(1);

        setDadosEspelhoComprador([]);
    }

    function handleCpf(e) {
        const attrForm = e.target.getAttribute('data-cpf');

        //console.log("attrForm = ", attrForm);
        let cpf = document.querySelector('.espelho-venda-cpf-comprador-' + attrForm);

        if (cpf.value.length) {
            cpfMask(cpf.value);
            cpf.value = cpfMask(cpf.value);

            if (cpf.value.length === 14) {
                setValidateCpfComprador(true);
            }
            else {
                setValidateCpfComprador(false);
            }
        }

        Axios.post(app + 'verificar_usuario_cpf', {
            "cpf": cpf.value
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then(res => {
                if (res.data.status && res.data.status === (401 || 498)) {
                    localStorage.clear();
                    history.push('/');
                }

                console.log(res.data.usuario);
                let usuario = res.data.usuario;
                if (usuario) {
                    //console.log("usuario existe");
                    //console.log(usuario.id);

                    //setIdVendedor(usuario.id);

                    //document.querySelector("#formGroup-vendedor-" + attrForm + " .cpf-vendedor-" + attrForm).value = "";
                    //document.querySelector("#vendedor_id-" + attrForm).value = usuario.id;
                    document.querySelector("#formGroup .espelho-venda-nome-comprador-" + attrForm).value = usuario.name;
                    document.querySelector("#formGroup .espelho-venda-telefone-comprador-" + attrForm).value = usuario.telefone;
                    document.querySelector("#formGroup .espelho-venda-email-comprador-" + attrForm).value = usuario.email;
                    document.querySelector("#formGroup .espelho-venda-logradouro-comprador-" + attrForm).value = usuario.endereco;

                    //setValidateCpfVendedor(true);
                    setValidateNomeComprador(true);
                    setValidateTelefoneComprador(true);
                    setValidateLogradouroComprador(true);

                } else {

                    //setIdVendedor("");

                    //console.log("usuario não existe");
                    //document.querySelector("#vendedor_id-" + attrForm).value = usuario.id;
                    document.querySelector("#formGroup .espelho-venda-nome-comprador-" + attrForm).value = "";
                    document.querySelector("#formGroup .espelho-venda-telefone-comprador-" + attrForm).value = "";
                    document.querySelector("#formGroup .espelho-venda-email-comprador-" + attrForm).value = "";
                    document.querySelector("#formGroup .espelho-venda-logradouro-comprador-" + attrForm).value = "";

                    setValidateNomeComprador(false);
                    setValidateTelefoneComprador(false);
                    setValidateLogradouroComprador(false);
                }
            })
    }

    const handleNome = () => {
        let nome = document.querySelector('.espelho-venda-nome-comprador-1');
        if (nome.value.length > 0) {
            setValidateNomeComprador(true);
        }
        else {
            setValidateNomeComprador(false);
        }
    }

    /*const handleCodigo = () => {
        let codigo = document.querySelector('.espelho-venda-codigo-Comprador-1');
        if (codigo.value.length > 0) {
            setValidateCodigoComprador(true);
        }
        else {
            setValidateCodigoComprador(false);
        }
    }*/

    const handleTelefone = () => {
        let telefone = document.querySelector('.espelho-venda-telefone-comprador-1');
        if (telefone.value.length) {
            phoneMask(telefone.value);
            telefone.value = phoneMask(telefone.value);

            if (telefone.value.length >= 14) {
                setValidateTelefoneComprador(true);
            }
        }
        else {
            setValidateTelefoneComprador(false);
        }
    }

    /*const handleEmail = () => {
        let telefone = document.querySelector('.espelho-venda-telefone-Comprador-1');
        if (telefone.value.length > 0) {
            setValidateEmailComprador(true);
        }
        else {
            setValidateEmailComprador(false);
        }
    }*/

    const handleBairro = () => {
        let bairro = document.querySelector('.espelho-venda-bairro-comprador-1');
        if (bairro.value.length > 0) {
            setValidateBairroComprador(true);
        }
        else {
            setValidateBairroComprador(false);
        }
    }

    const handleLogradouro = () => {
        let logradouro = document.querySelector('.espelho-venda-logradouro-comprador-1');
        if (logradouro.value.length > 0) {
            setValidateLogradouroComprador(true);
        }
        else {
            setValidateLogradouroComprador(false);
        }
    }

    /*const handleNomeConjuge = () => {
        let conjuge = document.querySelector('.espelho-venda-conjugue-comprador-1');
        if (conjuge.value.length > 0) {
            setValidateConjugeComprador(true);
        }
        else {
            setValidateConjugeComprador(false);
        }
    }*/

    /*const handleNomeProcurador = () => {
        let procurador = document.querySelector('.espelho-venda-procurador-comprador-1');
        if (procurador.value.length > 0) {
            setValidateProcuradorComprador(true);
        }
        else {
            setValidateProcuradorComprador(false);
        }
    }*/

    const handleTelefoneProcurador = () => {
        let procuradorTelefone = document.querySelector('.espelho-venda-telefone-procurador-comprador-1');
        if (procuradorTelefone.value.length) {
            phoneMask(procuradorTelefone.value);
            procuradorTelefone.value = phoneMask(procuradorTelefone.value);
            
            if (procuradorTelefone.value.length >= 14) {
                //setValidateTelefoneProcuradorComprador(true);
            }
        }
        else {
            //setValidateTelefoneProcuradorComprador(false);
        }
    }

    const handleDocObrigatorio = (e) => {
        let file = document.querySelector('.documento-obrigatorio input[type="file"]').files[0];
        console.log(file);

        setValidateDocObrigatorio(true);
    }

    //Adcionando e removendo campos de Documento
    const handleChangeTipoDocumento = (i, e) => {
        let newFormValues = [...formValues];
        newFormValues[i]['tipoDocumento'] = e.target.value;
        setFormValues(newFormValues);
        console.log(formValues);

        /*if (formValues.length > 0) {
            setValidateInputFile(true);   
        }
        else {
            setValidateInputFile(false);
        }*/

    }

    const handleChangeDocumento = (i, e) => {
        let file = document.querySelector('.upload-' + i + ' input[type="file"]').files[0];

        let newFormValues = [...formValues];
        newFormValues[i]['documento'] = file.name;
        setFormValues(newFormValues);
        console.log(formValues);

        /*if (formValues.length > 0) {
            setValidateInputFile(true);   
        }
        else {
            setValidateInputFile(false);
        }*/
    }

    const addFormFields = (e) => {
        e.preventDefault();
        setFormValues([...formValues, { documento: "" }])
    }

    const removeFormFields = (i) => {
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues)
        console.log(formValues);
    }

    /*const handleSubmit = (event) => {
        event.preventDefault();
        alert(JSON.stringify(formValues));
    }*/

    function validarSubmit() {
        if (validateNomeComprador === true &&
            validateTelefoneComprador === true &&
            validateBairroComprador === true &&
            validateLogradouroComprador === true &&
            validateDocObrigatorio === true
            //validateInputFile === true*/
            //validateCodigoComprador === true &&
            //validateEmailComprador === true &&
            //validateCepComprador === true &&
            //validateConjugeComprador === true &&
            //validateProcuradorComprador === true &&
            //validateTelefoneProcuradorComprador === true
        ) {
            return 'enabled';
        }
        else {
            return 'disabled';
        }
    }
    validarSubmit();

    const handleSalvarContinuar = (e) => {
        e.preventDefault();
        console.log('Salvar e Continuar');
    }

    const handleBtnPularEtapa = (e) => {
        e.preventDefault();
        console.log('Pular Etapa');
    }

    const handleBtnAnterior = (e) => {
        e.preventDefault();
        console.log('Anterior');

        setPosicaoEspelhoVenda(2);
    }

    const handleBtnAvancar = (e) => {
        e.preventDefault();
        console.log('Avançar');

        const arrayComprador = {
            cpf: document.querySelector('.espelho-venda-cpf-comprador-1').value,
            nome: document.querySelector('.espelho-venda-nome-comprador-1').value,
            codigo: document.querySelector('.espelho-venda-codigo-comprador-1').value,
            telefone: document.querySelector('.espelho-venda-telefone-comprador-1').value,
            email: document.querySelector('.espelho-venda-email-comprador-1').value,
            bairro: document.querySelector('.espelho-venda-bairro-comprador-1').value,
            logradouro: document.querySelector('.espelho-venda-logradouro-comprador-1').value,
            conjuge: document.querySelector('.espelho-venda-conjuge-comprador-1').value,
            procurador: document.querySelector('.espelho-venda-procurador-comprador-1').value,
            telefoneProcurador: document.querySelector('.espelho-venda-telefone-procurador-comprador-1').value,
            arquivos: formValues,
        }
        console.log(arrayComprador);

        setDadosEspelhoComprador(arrayComprador);

        setPosicaoEspelhoVenda(4);
        //closeEspelhoVenda(e);
    }

    return (
        <Pane>
            <Dialog
                width={808}
                isShown={isShowFormEspelhoVenda}
                title=''
                onCloseComplete={(e) => closeEspelhoVenda(e)}
                hasFooter={false}
                preventBodyScrolling
                shouldCloseOnOverlayClick={false}
                containerProps={{
                    className: 'form-dialog-props'
                }}
            >
                <Steps />

                <div className="form-dialog">
                    <h4 style={{ marginTop: '15px' }}>Dados do Comprador</h4>
                    <p className="descritption" style={{ marginTop: '15px' }}>Preencha os dados do comprador responsável.</p>

                    <div className="formGroup formAdd">
                        <form id="formGroup" encType="multipart/form-data">
                            <Pane>
                                <div className="rowForm">
                                    <TextInputField
                                        width={125}
                                        label="CPF"
                                        description=""
                                        placeholder="000.000.000-00"
                                        defaultValue={dadosEspelhoComprador === [] ? '' : dadosEspelhoComprador.cpf}
                                        id={"espelho-venda-cpf-comprador-1"}
                                        className={"espelho-venda-cpf-comprador-1"}
                                        data-cpf="1"
                                        onChange={(e) => handleCpf(e)}
                                        maxlength={14}
                                        required
                                    />

                                    <TextInputField
                                        width={430}
                                        label="Nome Completo"
                                        description=""
                                        placeholder="José Maria da Silva"
                                        defaultValue={dadosEspelhoComprador === [] ? '' : dadosEspelhoComprador.nome}
                                        id={"espelho-venda-nome-comprador-1"}
                                        className={"espelho-venda-nome-comprador-1"}
                                        onChange={(e) => handleNome(e)}
                                        required
                                    />

                                    <TextInputField
                                        width={100}
                                        label="Cód"
                                        description=""
                                        placeholder="Ex: 11111"
                                        defaultValue={dadosEspelhoComprador === [] ? '' : dadosEspelhoComprador.codigo}
                                        id={"espelho-venda-codigo-comprador-1"}
                                        className={"espelho-venda-codigo-comprador-1"}
                                        onChange={(e) => (e)}
                                        style={{ marginLeft: '20px' }}
                                    />
                                </div>

                                <div className="rowForm">
                                    <TextInputField
                                        width={216}
                                        label="Telefone/Celular"
                                        description=""
                                        placeholder="(21) 9999-9999"
                                        defaultValue={dadosEspelhoComprador === [] ? '' : dadosEspelhoComprador.telefone}
                                        id={"espelho-venda-telefone-comprador-1"}
                                        className={"espelho-venda-telefone-comprador-1"}
                                        onChange={(e) => handleTelefone(e)}
                                        maxLength={15}
                                        required
                                    />

                                    <TextInputField
                                        width={463}
                                        label="E-mail"
                                        description=""
                                        placeholder="gerente@gmail.com"
                                        defaultValue={dadosEspelhoComprador === [] ? '' : dadosEspelhoComprador.email}
                                        id={"espelho-venda-email-comprador-1"}
                                        className={"espelho-venda-email-comprador-1"}
                                        onChange={(e) => (e)}
                                    />
                                </div>

                                <div className="rowForm">
                                    <TextInputField
                                        width={216}
                                        label="Bairro"
                                        description=""
                                        placeholder="Botafogo"
                                        defaultValue={dadosEspelhoComprador === [] ? '' : dadosEspelhoComprador.bairro}
                                        id={"espelho-venda-bairro-comprador-1"}
                                        className={"espelho-venda-bairro-comprador-1"}
                                        onChange={(e) => handleBairro(e)}
                                        required
                                    />

                                    <TextInputField
                                        width={463}
                                        label="Logradouro"
                                        description=""
                                        placeholder="Rua Voluntários da Pátria"
                                        defaultValue={dadosEspelhoComprador === [] ? '' : dadosEspelhoComprador.logradouro}
                                        id={"espelho-venda-logradouro-comprador-1"}
                                        className={"espelho-venda-logradouro-comprador-1"}
                                        onChange={(e) => handleLogradouro(e)}
                                        required
                                    />
                                </div>

                                <div className="rowForm">
                                    <TextInputField
                                        width={463}
                                        label="Nome completo do Cônjugue/Companheiro(a)"
                                        description=""
                                        placeholder="José Maria da Silva"
                                        defaultValue={dadosEspelhoComprador === [] ? '' : dadosEspelhoComprador.conjuge}
                                        id={"espelho-venda-conjuge-comprador-1"}
                                        className={"espelho-venda-conjuge-comprador-1"}
                                        onChange={(e) => (e)}
                                    />
                                </div>

                                <div className="row-recibo">
                                    <div className="subtitle">Dados do procurador</div>
                                    <div className="rowForm">
                                        <TextInputField
                                            width={440}
                                            label="Nome completo - Procurador"
                                            description=""
                                            placeholder="Josér Maria da Silva"
                                            defaultValue={dadosEspelhoComprador === [] ? '' : dadosEspelhoComprador.nomeProcurador}
                                            id={"espelho-venda-procurador-comprador-1"}
                                            className={"espelho-venda-procurador-comprador-1"}
                                            onChange={(e) => (e)}
                                        />

                                        <TextInputField
                                            width={225}
                                            label="Telefone/Celular - Procurador"
                                            description=""
                                            placeholder="(21) 9999-9999"
                                            defaultValue={dadosEspelhoComprador === [] ? '' : dadosEspelhoComprador.telefoneProcurador}
                                            id={"espelho-venda-telefone-procurador-comprador-1"}
                                            className={"espelho-venda-telefone-procurador-comprador-1"}
                                            onChange={(e) => handleTelefoneProcurador(e)}
                                            maxLength={15}
                                        />
                                    </div>
                                </div>

                                <div className="row-recibo">
                                    <div className="subtitle">
                                        <CloudUploadIcon className="icon-subtitle" />
                                        Upload de documentos do comprador
                                    </div>

                                    <p className="descritption description-upload">Atenção: subir arquivos no formato .doc ou .pdf. <br /> Para aprender a converter uma foto para pdf., <a href="https://www.tecmundo.com.br/apps/72485-apps-converter-documentos-para-pdf-celulares-tablets.htm" target="_blank" rel="noreferrer" title="Converter foto para PDF">clique aqui</a>.</p>

                                    <div className={"rowForm upload-espelho-venda upload-obrigatorio"}>
                                        <TextInputField
                                            width={215}
                                            marginBottom={0}
                                            marginLeft={0}
                                            label=""
                                            description=""
                                            placeholder="RG*"
                                            defaultValue="RG*"
                                            id={"espelho-venda-docs-1 input-obrigatorio"}
                                            className={"espelho-venda-doc-1 input-obrigatorio"}
                                            onChange={(e) => (e)}
                                            readOnly
                                        />
                                        <input type="hidden" className="doc-hidden-comprador" id="doc-hidden-comprador" name="" value="20" />
                                        <FilePicker
                                            width={250}
                                            placeholder="nome.arquivo"
                                            type="file"
                                            name="documento-obrigatorio"
                                            value={''}
                                            onChange={e => handleDocObrigatorio(e)}
                                            className={"file-input documento-obrigatorio"}
                                        />
                                    </div>

                                    {formValues.map((e, index) => (
                                        <div className={"rowForm upload-espelho-venda upload-" + index} key={index}>
                                            <SelectField
                                                value={e.tipoDocumento || ""}
                                                onChange={e => handleChangeTipoDocumento(index, e)}
                                                name="tipoDocumento"
                                                className={'documento-imovel espelho-venda-comprador-tipo-documento espelho-venda-documento-comprador-novo-' + index}
                                                style={{ marginBottom: 0 }}
                                                id={'espelho-venda-documento-comprador-novo-' + index}
                                                data-documento={'tipo-documento-novo-' + index}
                                                width={216}
                                                marginBottom={0}
                                                padding={0}
                                            >
                                                <option value="0" hidden>Selecione o tipo</option>
                                                {
                                                    tipoDocumentos.filter(tipoDocumento => tipoDocumento.tipo === "pessoa fisica")
                                                        .map(tipoDocumento => <option value={tipoDocumento.id}>{tipoDocumento.nome}</option>)
                                                }
                                            </SelectField>

                                            <FilePicker
                                                width={250}
                                                placeholder="nome.arquivo"
                                                type="file"
                                                name="documento"
                                                value={e.documento || ""}
                                                onChange={e => handleChangeDocumento(index, e)}
                                                className={"file-input documento-" + index}
                                            />
                                            {
                                                index ?
                                                    <Button
                                                        marginRight={16}
                                                        appearance="primary"
                                                        intent="danger"
                                                        className="button remove"
                                                        style={{ left: '75px' }}
                                                        onClick={() => removeFormFields(index)}
                                                        type="button"
                                                    >
                                                        <DeleteIcon
                                                            size={10}
                                                            style={{ 'marginRight': '10px', 'fill': '#fff' }}
                                                        /> Excluir
                                                    </Button>
                                                    : null
                                            }
                                        </div>
                                    ))}

                                    <Button
                                        className="btn-add-documento"
                                        onClick={(e) => addFormFields(e)}
                                    >
                                        <PlusIcon className="icon-label" />
                                        Adicionar mais documentos
                                    </Button>
                                </div>

                                <div className="mensagem-campos msg-obrigatorio">*Campos obrigatórios</div>

                                <div className="footer-form">
                                    <div>
                                        <Button className="btn-minimal btn-minimal-disabled" appearance="default" disabled onClick={(e) => handleSalvarContinuar(e)}>
                                            Salvar e continuar depois
                                        </Button>
                                    </div>

                                    <div>
                                        <Button className="btn-minimal" appearance="default" onClick={(e) => handleBtnPularEtapa(e)}>
                                            Pular esta etapa
                                        </Button>

                                        <Button appearance="default" marginLeft={15} onClick={(e) => handleBtnAnterior(e)}>
                                            <ChevronLeftIcon className="icon-label" style={{ margin: '0 5px 0 0' }} />
                                            Anterior
                                        </Button>

                                        <Button
                                            appearance="primary"
                                            disabled={validarSubmit() === 'disabled' ? true : false}
                                            marginLeft={15}
                                            onClick={(e) => handleBtnAvancar(e)}
                                        >
                                            Avançar
                                            <ChevronRightIcon className="icon-save" />
                                        </Button>
                                    </div>
                                </div>
                            </Pane>
                        </form>
                    </div>
                </div>
            </Dialog>
        </Pane>
    )
}